<template>
  <li class="information">
    <div>
      <img v-if="iconImage" :src="iconImage" />
      <span class="information__body" :class="{ reverse: reverse }">
        <slot>
          <h5 v-if="hasTitle">
            {{ info.title }}
          </h5>
          <small v-if="hasDetail">
            {{ info.detail }}
          </small>
        </slot>
      </span>
    </div>
  </li>
</template>

<script>
export default {
  name: 'VehicleBasicInformationIcon',
  props: {
    info: {
      type: Object,
      default: () => ({}),
    },
    icon: {
      type: String,
      default: '',
    },
    reverse: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    iconImage() {
      return this.info.icon || this.icon;
    },
    hasTitle() {
      return this.info.title !== null && typeof this.info.title !== 'undefined';
    },
    hasDetail() {
      return this.info.detail !== null && typeof this.info.detail !== 'undefined';
    },
  },
};
</script>

<style lang="scss" scoped>
.information {
  &__body {
    display: flex;
    flex-direction: column;

    &.reverse {
      flex-direction: column-reverse;
    }
  }
}
</style>
